<template>
  <div class="modal fade" id="orcamentoModal" tabindex="-1" aria-labelledby="orcamentoModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="orcamentoModalLabel">Solicitar Orçamento</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="enviarFormulario">
            <input type="hidden" name="_subject" value="Nova Solicitação de Orçamento via Site">
            <input type="hidden" name="_captcha" value="false">
            <input type="hidden" name="_template" value="table">
            <input type="hidden" name="_next" value="https://hammernaval.com.br/obrigado">
            
            <div class="row g-3">
              <div class="col-md-6">
                <label for="nome" class="form-label">Nome Completo *</label>
                <input type="text" class="form-control" id="nome" name="nome" v-model="formData.nome" required>
              </div>
              <div class="col-md-6">
                <label for="email" class="form-label">E-mail *</label>
                <input type="email" class="form-control" id="email" name="email" v-model="formData.email" required>
              </div>
              <div class="col-md-6">
                <label for="telefone" class="form-label">Telefone *</label>
                <input type="tel" class="form-control" id="telefone" name="telefone" v-model="formData.telefone" required>
              </div>
              <div class="col-md-6">
                <label for="empresa" class="form-label">Empresa</label>
                <input type="text" class="form-control" id="empresa" name="empresa" v-model="formData.empresa">
              </div>
              <div class="col-12">
                <label for="servico" class="form-label">Serviço de Interesse *</label>
                <select class="form-select" id="servico" name="servico" v-model="formData.servico" required>
                  <option value="">Selecione um serviço</option>
                  <option value="Consultoria">Consultoria</option>
                  <option value="Inspeção">Inspeção</option>
                  <option value="Manutenção">Manutenção</option>
                </select>
              </div>
              <div class="col-12">
                <label for="mensagem" class="form-label">Mensagem *</label>
                <textarea class="form-control" id="mensagem" name="mensagem" rows="4" v-model="formData.mensagem" required></textarea>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-primary">
                Enviar Solicitação
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrcamentoModal',
  data() {
    return {
      enviando: false,
      formData: {
        nome: '',
        email: '',
        telefone: '',
        empresa: '',  
        servico: '',
        mensagem: ''
      }
    }
  },
  methods: {
    async enviarFormulario() {
      this.enviando = true;
      try {
        const response = await fetch('https://hammernaval.com.br/orcamento.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nome: this.formData.nome,
            email: this.formData.email,
            telefone: this.formData.telefone,
            empresa: this.formData.empresa,
            servico: this.formData.servico,
            mensagem: this.formData.mensagem
          })
        });

        if (!response.ok) {
          throw new Error('Erro ao enviar formulário');
        }

        const data = await response.json();
        alert('Formulário enviado com sucesso!');
        this.resetForm();
      } catch (error) {
        console.error('Erro:', error);
        alert('Erro ao enviar formulário. Por favor, tente novamente.');
      } finally {
        this.enviando = false;
      }
    },
    resetForm() {
      this.formData = {
        nome: '',
        email: '',
        telefone: '',
        empresa: '',
        servico: '',
        mensagem: ''
      };
      this.$el.querySelector('form').reset();
    }
  }
}
</script>

<style scoped>
.modal-content {
  border-radius: 1rem;
}

.modal-header {
  border-bottom: 1px solid rgba(0,0,0,0.1);
  padding: 1.5rem;
}

.modal-body {
  padding: 1.5rem;
}

.form-label {
  font-weight: 500;
  color: #333;
}

.form-control, .form-select {
  border-radius: 0.5rem;
  padding: 0.75rem;
  border: 1px solid #ddd;
}

.form-control:focus, .form-select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.2rem rgba(0, 36, 65, 0.25);
}

.btn-primary {
  padding: 0.75rem 2rem;
  border-radius: 0.5rem;
  font-weight: 500;
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style> 